export const API_ROUTES = {
  // public routes
  LOG_IN: "/admin-panel-auth/v1/sign-in",
  IP_WHITELIST_STATUS: "/admin-panel-auth/v1/ip-whitelist/status",
  REFRESH_TOKEN: "/admin-panel/auth/v1/refresh-token",
  SIGN_OUT: "/admin-panel-auth/v1/sign-out",
  SET_PASSWORD: "/admin-panel-auth/v1/set-password",
  RESET_PASSWORD: "/admin-panel-auth/v1/reset-password",
  PASSWORD_POLICY_CHECK: "/admin-panel-auth/v1/password-policy/check",
  PAM_MFA_ASSOCIATE: "/admin-panel-auth/v1/mfa/associate",
  PAM_MFA_VERIFY: "/admin-panel-auth/v1/mfa/verify",
  PAM_MFA_CHALLENGE: "/admin-panel-auth/v1/mfa/challenge",
  GET_PLATFORM_CONFIG: "/admin-panel/platform/v1/config",
  GET_PLATFORM_CONFIG_V2: "/admin-panel/platform/v2/config",
  GET_ADMINS_SELF_DATA: "/admin-panel-staff/v1/auth/me",
  // GET_PERMISSIONS: '/get-admin-permission',
  // user routes
  GET_USERS: "/admin-panel-users/v1", // '/all-users'
  GET_USER_BALANCE_HISTORY: "/admin-panel-users/v1/{user_id}/balance-history",
  SEARCH_USER: "/admin-panel-users/v1?search=", // '/search-user'
  // Async CSV export of the Users list. Async endpoints under /admin-panel-v2
  // — POST creates the job, GET polls its status until succeeded/failed.
  USERS_EXPORT_START: "/admin-panel-v2/users/exports",
  USERS_EXPORT_STATUS: "/admin-panel-v2/users/exports/{export_id}",
  USERS_EXPORT_COLUMNS: "/admin-panel-v2/users/exports/columns",
  GET_USER_BETS: "/admin-panel-users/v1/{user_id}/bets", // '/get-user-bets',
  GET_USER_CASINO_BETS: "/admin-panel-users/v1/{user_id}/bets", // '/get-user-casino-bets',
  GET_BETS_FILTER_DROPDOWNS: "/admin-panel-users/v1/bets/filter-dropdowns",
  USERS_FILTER_DROPDOWNS: "/admin-panel-users/v1/filter-dropdowns",
  GET_BET_BY_ID: "/admin-panel/bets/v1/{user_id}/{bet_id}/{bet_type}", // '/retrieve-bet-details',
  GET_PIKKEM_USER_BETS: "/admin-panel-pikkem/v1/users/{user_id}/bets",
  SETTLE_PIKKEM_BET: "/admin-panel/bets/v1/settle/pikkem",
  SETTLE_ROUND_ROBIN_BET: "/admin-panel/bets/v1/settle/round-robin", // '/settle-round-robin-bet',
  SETTLE_PARLAY_BET: "/admin-panel/bets/v1/settle/parlay", // '/settle-parlay-bet',
  // GET_USER_CASINO_BETS: '/get-user-casino-bets',
  EDIT_USER_PROFILE: "/admin-panel-users/v1/{user_id}", // '/edit-user-profile',
  EDIT_USER_WALLET: "/admin-panel-users/v1/{user_id}/wallet", // '/update-user-wallet',
  DELETE_USER: "/admin-panel-users/v1/by-username/{user_name}", // '/delete-user',
  CHANGE_USER_ACH: "/admin-panel-users/v1/{user_id}/ach-status", // '/update-user-ach-status',
  SUSPEND_UNSUSPEND_USER: "/admin-panel-users/v1/{user_id}/status", // '/suspend-unsuspend-user',
  GET_TRANSACTION_HISTORY: "/admin-panel-users/v1/{user_id}/transactions", // '/get-user-transaction-history',
  // Details for a single transaction. V1 is DynamoDB-backed and resolves
  // internal ids (including `manual_review_<uuid>`); V2 only knows provider
  // transaction ids, so it serves the Report Generator list and nothing else.
  GET_USER_TRANSACTION_DETAILS_V1:
    "/admin-panel-users/v1/{user_id}/transactions/{transaction_id}/details",
  GET_USER_TRANSACTION_DETAILS_V2:
    "/admin-panel-v2/users/{user_id}/transactions/{transaction_id}/details",
  // User Manager Promotions tab. Lake-backed: HTTP 503 must surface as an
  // error, not degrade to empty KPIs / an empty table.
  GET_USER_PROMOTIONS: "/admin-panel-v2/users/{user_id}/promotions",
  GET_USER_PROMOTIONS_KPIS: "/admin-panel-v2/users/{user_id}/promotions/kpis",
  GET_USER_REFERRALS: "/admin-panel-v2/users/{user_id}/referrals",
  GET_USER_REFERRALS_KPIS: "/admin-panel-v2/users/{user_id}/referrals/kpis",

  GET_TRANSACTIONS_FILTER_DROPDOWNS:
    "/admin-panel-users/v1/transactions/filter-dropdowns",
  GET_PAYMENT_INSTRUMENTS: "/admin-panel-users/v1/{user_id}/bank-accounts?payment_mode={payment_mode}", // '/fetch-user-bank-accounts',
  DELETE_ALL_PAYMENT_INSTRUMENTS:
    "/admin-panel-users/v1/{user_id}/bank-accounts?payment_mode={payment_mode}", // '/delete-user-bank-accounts',
  DELETE_SPECIFIC_PAYMENT_INSTRUMENT:
    "/admin-panel-users/v1/{user_id}/bank-accounts/{bank_id}?payment_mode={payment_mode}", // '/delete-bank-from-bank-list',
  SEND_EMAIL_VERIFICATION: "/admin-panel/admin/v1/auth/verification-code", // '/send-verification-code-to-email',
  EDIT_SINGLE_BET: "/admin-panel/bets/v1/settle/single", // '/settle-sportbook-bet',
  EDIT_PARLAY_BET: "/admin-panel/bets/v1/settle/parlay", // '/settle-parlay-bet',
  EDIT_GROUP_BET: "/admin-panel/bets/v1/settle/group", // '/settle-group-bet',
  EDIT_P2P_BET: "/admin-panel/bets/v1/settle/peer", // '/settle-p2p-bet',
  GET_EVENT_CODES_LIST: "/admin-panel-events/v1/codes", // '/get-event-codes-list',
  UPDATE_EVENT_CODE: "/admin-panel-events/v1/codes/{code}", // '/update-event-code',
  GET_PLAID_STATUS_BY_DAY:
    "/admin-panel/metrics/v1/users/plaid-status?period=daily", // '/get-plaid-status-by-day',
  ADD_EVENT_CODE: "/admin-panel-events/v1/codes", // '/add-event-code',
  GET_USERS_TOU_STATUS: "/admin-panel-users/v1/terms-of-use/status", // '/get-users-tou-status',
  USERS_DEPOSIT_ATTEMPTS: "/admin-panel-users/v1/{user_id}/deposit-attempts", // '/users-deposit-attempts',
  USERS_PERSONAL_LIMIT: "/admin-panel-users/v1/{user_id}/personal-limit", // '/users-personal-limit',
  UPDATE_USER_LOCKED_LIMIT: "/admin-panel-users/v1/{user_id}/locked-limit", // '/update-user-locked-limit',
  SET_USERS_PERSONAL_LIMIT: "/admin-panel-users/v1/{user_id}/personal-limit", // '/set-users-personal-limit',
  // Withdrawals block flag (`is_prevent_from_withdraw`). Owned by the
  // Payments backend. Manual-only in PAM but the backend may also flip it
  // via automated systems (fraud / risk). GET reads the current value,
  // PATCH writes it — both share the same path.
  USER_WITHDRAW_PREVENTION:
    "/admin-panel-users/v1/{user_id}/withdraw-prevention",
  // Bonuses enabled flag. PATCH writes whether future bonus eligibility is allowed.
  USER_BONUS_ENABLED: "/admin-panel-users/v1/{user_id}/bonuses/enabled",
  USER_REFERRER_BONUS_ENABLED:
    "/admin-panel-users/v1/{user_id}/referrer-bonus/enabled",
  GIVE_USER_FREE_PICK: "/admin-panel-users/v1/{user_id}/free-picks", // '/give-user-free-pick',
  GIVE_USER_PROFIT_BOOST: "/admin-panel-users/v1/{user_id}/profit-boosts", // '/give-user-profit-boost',
  // Free Spins routes
  GET_FREE_SPINS_GAMES: "/admin-panel-users/v1/free-spins/games", // '/get-free-spins-games',
  GIVE_USER_FREE_SPINS: "/admin-panel-users/v1/{user_id}/free-spins", // '/give-user-free-spins', -- BONENG-718: superseded by ISSUE_FREE_SPINS_V2
  ISSUE_FREE_SPINS_V2: "/admin-panel-v2/bonus/freespins",
  GET_ALT_ODDS: "/admin-panel/metrics/v1/alt-odds?user_id={user_id}", // '/get-alt-odds',
  GET_ALT_ODDS_HISTORY:"/admin-panel/metrics/v1/alt-odds/history?user_id={user_id}", // '/get-alt-odds-history',
  UPDATE_USER_APPSTORE_REVIEW_STATUS:"/admin-panel-users/v1/{user_id}/app-store-review-status", // '/update-user-appstore-review-status',
  UPDATE_USER_GAME_PASS_STATUS:"/admin-panel-users/v1/{user_id}/game-pass-status", // '/update-user-game-pass-enabled-status',
  UPDATE_USER_GAME_PASS_PREMIUM_STATUS:"/admin-panel-users/v1/{user_id}/game-pass-premium-status", // '/update-user-game-pass-premium-status',
  UPDATE_USER_GLOBAL_CHAT_STATUS: '/admin-panel-users/v1/{user_id}/global-chat-toggle', // '/update-user-global-chat-status',
  GET_USER_BET_LIMITS_TIER: "/admin-panel-users/v1/{user_id}/bet-limits-tier",
  UPDATE_USER_BET_LIMITS_TIER: "/admin-panel-users/v1/{user_id}/bet-limits-tier",
  GET_SEON_COOLDOWN: "/admin-panel-users/v1/{user_id}/seon-cooldown",
  CLEAR_SEON_COOLDOWN: "/admin-panel-users/v1/{user_id}/seon-cooldown/clear",

  // User Notes — admin-authored notes attached to a player profile.
  // List is pinned-first, newest-first. Edit/Delete restricted to the
  // original author; Unpin allowed for the author or whoever pinned it.
  GET_USER_NOTES: "/admin-panel-users/v1/{user_id}/notes",
  CREATE_USER_NOTE: "/admin-panel-users/v1/{user_id}/notes",
  EDIT_USER_NOTE: "/admin-panel-users/v1/{user_id}/notes/{note_id}",
  PIN_USER_NOTE: "/admin-panel-users/v1/{user_id}/notes/{note_id}/pin",
  UNPIN_USER_NOTE: "/admin-panel-users/v1/{user_id}/notes/{note_id}/unpin",
  DELETE_USER_NOTE: "/admin-panel-users/v1/{user_id}/notes/{note_id}",

  // Sportsbook bet limits (platform-level min/max bet per currency). Coordinate with backend for exact paths.
  GET_SPORTSBOOK_BET_LIMITS: "/admin-panel/settings/v1/bet-limits",
  UPDATE_SPORTSBOOK_BET_LIMITS: "/admin-panel/settings/v1/bet-limits",
  GET_QUICK_BET_DEFAULTS: "/admin-panel/settings/v1/quick-bet-defaults",
  UPDATE_QUICK_BET_DEFAULTS: "/admin-panel/settings/v1/quick-bet-defaults",

  /** Per-deployment DynamoDB account config (META, FEATURE, VENDOR, …). */
  GET_ACCOUNT_CONFIG: "/admin-panel/settings/v1/account-config",
  UPDATE_ACCOUNT_CONFIG_ROW: "/admin-panel/settings/v1/account-config/row",

  /** KYC checkpoint flow ↔ provider checkpoint_id mapping (Compliance → Configuration). */
  GET_SURT_CHECKPOINTS: "/admin-panel/settings/v1/surt-checkpoints",
  UPDATE_SURT_CHECKPOINT: "/admin-panel/settings/v1/surt-checkpoints",

  /**
   * Configurations → State Configuration (PENG-78 / PENG-84).
   * GET `/experiences-config` returns a map keyed by 2-letter state code
   * (`{ AK: { experiences: { prediction, sweepstakes } }, ... }`).
   * PATCH `/experiences-config/{state}` updates one state; body is
   * `{ experiences: { prediction, sweepstakes } }`.
   */
  GET_STATE_CONFIGS: "/admin-panel/settings/v1/experiences-config",
  UPDATE_STATE_CONFIG: "/admin-panel/settings/v1/experiences-config/{state}",

  /**
   * Compliance → Maintenance Mode.
   * GET → `{ web: boolean, mobile: boolean }` (gated by `.view`)
   * PATCH → partial `{ web?: boolean, mobile?: boolean }`, returns full status
   * (gated by `.update`).
   */
  GET_MAINTENANCE_MODE: "/admin-panel-v2/compliance/maintenance-mode",
  UPDATE_MAINTENANCE_MODE: "/admin-panel-v2/compliance/maintenance-mode",

  // kpi routes
  GET_SPORTRADAR_BET_METRICS: "/admin-panel/metrics/v1/betting", // '/get-betting-metrics',
  REFRESH_SPORTRADAR_BET_METRICS: "/admin-panel/metrics/v1/betting/refresh", // '/refresh-betting-metrics',
  GET_TOTAL_NUM_USERS: "/admin-panel/metrics/v1/users/total", // '/get-total-users',
  GET_TOTAL_EMAIL_VERIFIED:
    "/admin-panel/metrics/v1/users/email-status?period=total", // '/get-email-status',
  GET_TOTAL_PLAID_VERIFIED:
    "/admin-panel/metrics/v1/users/plaid-status?period=total", // '/get-plaid-status',
  GET_TOTAL_PURCHASES: "/admin-panel/metrics/v1/payments/totals?type=purchases", // '/get-total-purchases',
  GET_TOTAL_PRIZE_REDEMPTIONS:
    "/admin-panel/metrics/v1/payments/totals?type=redemptions", // '/get-total-redemptions',
  GET_TOTAL_REVENUE: "/admin-panel/metrics/v1/payments/totals?type=revenue", // '/get-total-revenue',
  GET_TOTAL_REDEEMABLE_AMOUT:
    "/admin-panel-payments/v1/redeemable-amount/total", // '/get-total-redeemable-amount',
  GET_TRANSACTIONS_BY_STATE: "/admin-panel/metrics/v1/transactions/by-state", // '/get-transactions-by-state',
  REFRESH_TRANSACTIONS_BY_STATE:
    "/admin-panel/metrics/v1/transactions/by-state/refresh", // '/refresh-transactions-by-state ',
  GET_EMAIL_STATUS:
    "/admin-panel/metrics/v1/users/email-status", // '/get-email-status-by-day',
  GET_FREE_CASH_METRICS: "/admin-panel/metrics/v1/free-cash", // '/get-free-cash-metrics',
  GET_PROFIT_BOOST_METRICS:
    "/admin-panel/metrics/v1/profit-boost?type=revenue&group_by=day", // '/get-profit-boost-metrics',
  GET_PAYMENT_ROUTING_SETTINGS:
    "/admin-panel-payments/v1/providers/routing/settings",
  UPDATE_PAYMENT_ROUTING_SETTINGS:
    "/admin-panel-payments/v1/providers/routing/settings",
  GET_APPLE_PAY_ROUTING_SETTINGS:
    "/admin-panel-payments/v1/providers/apple-pay/settings",
  UPDATE_APPLE_PAY_ROUTING_SETTINGS:
    "/admin-panel-payments/v1/providers/apple-pay/settings",
  APPLE_PAY_PROVIDER_ROUTING:
    "/admin-panel-payments/v1/providers/apple-pay/routing/provider-routing",
  PAYMENT_REPORTING_KPIS:
    "/admin-panel-v2/financials/analytics/payments/summary/kpis",
  PAYMENT_REPORTING_DEPOSITS_SUMMARY:
    "/admin-panel-v2/financials/analytics/payments/summary/deposits",
  PAYMENT_TRANSACTIONS:
    "/admin-panel-v2/financials/analytics/payments/transactions",
  PAYMENT_TRANSACTIONS_EXPORT_START:
    "/admin-panel-v2/financials/analytics/payments/transactions/exports",
  PAYMENT_TRANSACTIONS_EXPORT_STATUS:
    "/admin-panel-v2/financials/analytics/payments/transactions/exports/{export_id}",
  PAYMENT_TRANSACTIONS_EXPORT_COLUMNS:
    "/admin-panel-v2/financials/analytics/payments/transactions/exports/columns",

  //Affiliate routes
  // Operator-facing — staff bearer token, requires affiliates.write/read.
  CREATE_AFFILIATE: "/admin-panel-affiliates/v1/affiliates",
  AFFILIATE_CONTRACT_UPLOAD_URL:
    "/admin-panel-affiliates/v1/affiliates/contracts/upload-url",
  AFFILIATE_CONTRACT_DOWNLOAD_URL:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/contract/download-url",
  GET_AFFILIATE_BY_ID: "/admin-panel-affiliates/v1/affiliates/{affiliate_id}",
  LIST_AFFILIATES: "/admin-panel-affiliates/v1/affiliates",
  PATCH_AFFILIATE: "/admin-panel-affiliates/v1/affiliates/{affiliate_id}",
  CHANGE_AFFILIATE_EMAIL:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/email",
  AFFILIATE_RESET_PASSWORD:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/reset-password",
  DEACTIVATE_AFFILIATE:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/deactivate",
  REACTIVATE_AFFILIATE:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/reactivate",
  GET_AFFILIATE_PROMO_CODES:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/promo-codes",
  // Affiliate profile → Users tab (sibling to Promo Codes / Personal Info).
  // Same DynamoDB cursor + limit shape as `/promo-codes`; filters are
  // server-side once BE extends the query schema.
  GET_AFFILIATE_USERS:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/users",
  // Reporting/analytics — Module-level (all affiliates) + per-affiliate variants.
  AFFILIATE_ANALYTICS_KPIS:
    "/admin-panel-affiliates/v1/affiliates/analytics/kpis",
  AFFILIATE_ANALYTICS_NEW_USERS_FTDS:
    "/admin-panel-affiliates/v1/affiliates/analytics/new-users-ftds",
  AFFILIATE_ANALYTICS_FINANCIAL_PERFORMANCE:
    "/admin-panel-affiliates/v1/affiliates/analytics/financial-performance",
  AFFILIATE_ANALYTICS_TOP_AFFILIATES:
    "/admin-panel-affiliates/v1/affiliates/analytics/top-affiliates",
  AFFILIATE_ANALYTICS_TOP_PROMO_CODES:
    "/admin-panel-affiliates/v1/affiliates/analytics/top-promo-codes",
  AFFILIATE_ANALYTICS_GEO:
    "/admin-panel-affiliates/v1/affiliates/analytics/geo",
  AFFILIATE_DETAIL_ANALYTICS_KPIS:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/kpis",
  AFFILIATE_DETAIL_ANALYTICS_NEW_USERS_FTDS:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/new-users-ftds",
  AFFILIATE_DETAIL_ANALYTICS_FINANCIAL_PERFORMANCE:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/financial-performance",
  AFFILIATE_DETAIL_ANALYTICS_TOP_PROMO_CODES:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/top-promo-codes",
  AFFILIATE_DETAIL_ANALYTICS_GEO:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/geo",
  AFFILIATE_DETAIL_ANALYTICS_USERS:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/users",
  // CSV report downloads — return a signed-S3-URL envelope.
  AFFILIATE_LIST_DOWNLOAD:
    "/admin-panel-affiliates/v1/affiliates/analytics/reports/download",
  AFFILIATE_DETAIL_DOWNLOAD:
    "/admin-panel-affiliates/v1/affiliates/{affiliate_id}/analytics/reports/download",
  AFFILIATE_PORTAL_VIEW_DOWNLOAD:
    "/admin-panel-affiliates/v1/affiliates-portal/view/download",
  // Portal — affiliate user, sign-in is public and /me uses IdToken bearer.
  AFFILIATE_PORTAL_SIGN_IN: "/admin-panel-affiliates/v1/affiliate-portal/sign-in",
  AFFILIATE_PORTAL_SET_PASSWORD: "/admin-panel-affiliates/v1/affiliate-portal/set-password",
  AFFILIATE_PORTAL_ME: "/admin-panel-affiliates/v1/affiliates-portal/me",
  AFFILIATE_PORTAL_VIEW: "/admin-panel-affiliates/v1/affiliates-portal/view",
  // Portal analytics — same reporting surface as the operator endpoints but
  // scoped to the signed-in affiliate by the token; BE strips financial
  // metrics via AccessMode=RESTRICTED.
  AFFILIATE_PORTAL_ANALYTICS_KPIS:
    "/admin-panel-affiliates/v1/affiliates-portal/analytics/kpis",
  AFFILIATE_PORTAL_ANALYTICS_NEW_USERS_FTDS:
    "/admin-panel-affiliates/v1/affiliates-portal/analytics/new-users-ftds",
  AFFILIATE_PORTAL_ANALYTICS_TOP_PROMO_CODES:
    "/admin-panel-affiliates/v1/affiliates-portal/analytics/top-promo-codes",
  AFFILIATE_PORTAL_ANALYTICS_GEO:
    "/admin-panel-affiliates/v1/affiliates-portal/analytics/geo",
  AFFILIATE_PORTAL_ANALYTICS_USERS:
    "/admin-panel-affiliates/v1/affiliates-portal/analytics/users",

  // Regulator portal — the pinned contract is a single authenticated `/me`
  // that answers staff, affiliate and regulator callers, adding the regulator
  // `audience` block synthesized from the AccessToken. If BE relocates it at
  // integration, this constant plus `queries/regulator-portal/regulatorMeClient`
  // are the only edits.
  REGULATOR_ME: "/admin-panel-regulators/v1/me",
  // Compliance-service proxy. Tenant (regulator/client) is injected by the
  // BFF from client-configs — do not send those as query params.
  REGULATOR_COMPLIANCE_RULES: "/admin-panel-regulators/v1/rules",
  REGULATOR_COMPLIANCE_RESULTS: "/admin-panel-regulators/v1/results",
  REGULATOR_COMPLIANCE_RESULT_BY_ID:
    "/admin-panel-regulators/v1/results/{result_id}",
  REGULATOR_COMPLIANCE_PROMOTABLE_SERVICES:
    "/admin-panel-regulators/v1/promotable-services",
  REGULATOR_COMPLIANCE_APPROVALS: "/admin-panel-regulators/v1/approvals",
  REGULATOR_COMPLIANCE_APPROVE_RUNNING:
    "/admin-panel-regulators/v1/approvals/running",
  REGULATOR_COMPLIANCE_VERIFY: "/admin-panel-regulators/v1/verify",
  REGULATOR_COMPLIANCE_MANIFESTS: "/admin-panel-regulators/v1/manifests",

  STAFF_REGULATORS: "/admin-panel-regulators/v1/regulators",
  STAFF_REGULATOR_BY_ID: "/admin-panel-regulators/v1/regulators/{admin_id}",
  STAFF_REGULATOR_APPROVE:
    "/admin-panel-regulators/v1/regulators/{admin_id}/approve",
  STAFF_REGULATOR_REVOKE:
    "/admin-panel-regulators/v1/regulators/{admin_id}/revoke",

  // Legacy affiliate metrics (mock-only, kept for the analytics surfaces that
  // still need them.
  REFRESH_ADMIN_AFFILIATE_DATA: "/admin-panel/affiliates/v1/admin-data/refresh", // '/refresh-admin-affiliate-data',
  GET_ALL_REFERRAL_CODES: "/admin-panel/commissions/v1/referral-codes", // '/get-all-referral-codes',
  GET_FTD_LIST: "/admin-panel/affiliates/v1/ftd", // '/get-ftd-list',
  GET_FTD_LIST_BY_DAY: "/admin-panel/affiliates/v1/ftd?period=daily", // '/get-ftd-list-by-day',
  TOTAL_YEAR_COMMISSION_PAIDOUT: "/admin-panel/commissions/v1/yearly/paidout", // '/total-year-commission-paidout',
  GET_AVG_CAC: "/admin-panel/commissions/v1/metrics/avg-cac", // '/get-avg-cac',
  ADMINS_TOTAL_COMMISSION_MONTHLY:
    "/admin-panel/commissions/v1/admins/commission?period=monthly", // '/admins-total-commission-month',
  GET_TOTAL_FTDS: "/admin-panel/commissions/v1/metrics/ftds?period=total", // '/get-total-ftds',
  GET_TOTAL_MONTHLY_FTDS:
    "/admin-panel/commissions/v1/metrics/ftds?period=monthly", // '/get-total-monthly-ftds',
  GET_TOTAL_MONTHLY_DEPOSIT_RATIO:
    "/admin-panel/affiliates/v1/metrics/deposit-ratio?period=monthly", // '/total-monthly-deposit-ratio',
  GET_REFERRAL_STATS:
    "/admin-panel/affiliates/v1/referral-codes/stats?referral_codes={abc123}", // '/get-referral-stats',
  ADMINS_TOTAL_REVENUE: "/admin-panel/commissions/v1/admins/revenue/total", // '/admins-total-revenue',
  TOP_PERFORMERS_CURRENT_MONTH:
    "/admin-panel/commissions/v1/metrics/top-performers/current-month", // '/top-performers-current-month',
  AVG_MONTHLY_LTV: "/admin-panel/commissions/v1/metrics/ltv/monthly-avg?", // '/avg-monthly-ltv',
  TOTAL_SIGNUPS_YEAR:
    "/admin-panel/commissions/v1/metrics/signups?period=yearly", // '/total-signups-year',
  TOTAL_MONTHLY_SIGNUPS:
    "/admin-panel/commissions/v1/metrics/signups?period=monthly", // '/total-monthly-signups',
  // TOTAL_DEPOSIT_RATIO: "/admin-panel/affiliates/v1/metrics/deposit-ratio?period=yearly",                // '/total-deposit-ratio',
  AVG_MONTHLY_REVENUE:
    "/admin-panel/commissions/v1/metrics/revenue/monthly-avg?", //  '/avg-monthly-revenue',
  ADMINS_TOTAL_COMMISSION_MONTH_BREAKDOWN:
    "/admin-panel/commissions/v1/admins/monthly/breakdown?", // 'admins-total-commission-month-breakdown',
  // admin routes
  CREATE_ADMIN: "/admin-panel/admin/v1/users", // '/create-admin-user',
  EDIT_ADMIN: "/admin-panel/admin/v1/users/{admin_id}", // '/update-admin-group',
  GET_ADMIN_BY_ID: "/admin-panel/admin/v1/users/{admin_id}", // get single admin/staff details
  GET_ADMINS: "/admin-panel/admin/v1/users", // '/get-admins',
  DELETE_ADMIN: "/admin-panel/admin/v1/users/batch-delete", //  '/delete-admin',

  // promotions routes
  FETCH_INITIAL_DEPOSIT_AND_REFERRER_VALUES:
    "/admin-panel/referrals/v1/sportsbook-config", // '/fetch-initial-deposit-and-referrer-values',
  UPDATE_INITIAL_DEPOSIT_AND_REFERRER_VALUES:
    "/admin-panel/referrals/v1/sportsbook-config", // '/update-initial-deposit-and-referrer-values',
  GET_USER_ACTIVE_BONUSES: "/admin-panel-users/v1/{user_id}/bonuses", // '/get-user-active-bonuses',
  EXPIRE_USER_PROMOTION:
    "/admin-panel-users/v1/{user_id}/promotions/{promotion_id}", //  '/expire-user-promotion',
  GET_PROMOTIONS_DASHBOARD: "/dashboard/promotion_management",
  FETCH_CASINO_INITIAL_DEPOSIT_AND_REFERRER_VALUES: "/admin-panel/referrals/v1/casino-config", // '/fetch-casino-initial-deposit-and-referrer-values',
  FETCH_V2_WELCOME_BONUS_CONFIG: "/admin-panel/referrals/v2/welcome-bonus",
  UPDATE_V2_WELCOME_BONUS_CONFIG: "/admin-panel/referrals/v2/welcome-bonus",
  FETCH_V2_REFERRAL_BONUS_CONFIG: "/admin-panel/referrals/v2/referral-bonus",
  UPDATE_V2_REFERRAL_BONUS_CONFIG: "/admin-panel/referrals/v2/referral-bonus",
  // payments routes
  REDEMPTIONS_PENDING: "/admin-panel-payments/v1/redemptions/pending", // '/redemptions-pending',
  TOTAL_PENDING_REDEMPTIONS_AMOUNT:
    "/admin-panel-payments/v1/redemptions/pending/total", //'/total-pending-redemptions-amount',
  PENDING_REDEMPTIONS_TRIGGER: "/admin-panel-payments/v1/redemptions/trigger", // '/pending-redemptions-trigger',
  DELETE_SINGLE_PENDING_REDEMPTION:
    "/admin-panel-payments/v1/redemptions/{user_id}/{transaction_id}", //'/delete-single-pending-redemption',

  // reports routes
  LIST_DM_REPORTS: "/admin-panel-reports/v1/dm", // '/list-dm-reports',
  CLOSE_DM_REPORT: "/admin-panel-reports/v1/dm/close", // '/close-dm-report',

  // card details
  GET_CARD_DETAILS: "/admin-panel-users/v1/{user_id}/cards", // '/get-card-details',
  DELETE_CARD_FROM_CARDS_LIST:
    "/admin-panel-users/v1/{user_id}/cards/{card_id}", // '/delete-card-from-cards-list',
  DELETE_ALL_CARDS: "/admin-panel-users/v1/{user_id}/cards", // '/delete-all-cards',

  // Feature Management - Casino
  GET_CASINO_GAMES: "/admin-panel-casino/v1/games", // '/get-casino-games',
  LOAD_NEW_CASINO_GAMES: "/admin-panel-casino/v1/sync", // '/load-new-casino-games',
  GET_GAME_TOP_PLAYERS:
    "/admin-panel-casino/v1/games/{game_id}/top-players", // '/get-game-top-players',
  TOGGLE_CASINO_GAME_STATUS:
    "/admin-panel-casino/v1/entities/{entity_id}/games/{game_id}/status", // 'toggle-game-status-for-casino-entity',
  REMOVE_GAME_FROM_CASINO_ENTITY:
    "/admin-panel-casino/v1/entities/{entity_id}/games/{game_id}", // 'remove-game-from-casino-entity',
  ADD_CASINO_ENTITY: "/admin-panel-casino/v1/entities", // 'add-casino-entity',
  ADD_GAME_IN_CASINO_ENTITY:
    "/admin-panel-casino/v1/entities/{entity_id}/games", // 'add-game-in-casino-entity',
  TOGGLE_CASINO_ENTITY_STATUS:
    "/admin-panel-casino/v1/entities/{entity_id}/status", // 'toggle-casino-entity-status',
  CHANGE_CASINO_ENTITY_ORDER:
    "/admin-panel-casino/v1/entities/{entity_id}/order", // 'change-casino-entity-order',
  CHANGE_GAME_ORDER_FOR_CASINO_ENTITY:
    "/admin-panel-casino/v1/entities/{entity_id}/games/{game_id}/order", // 'change-game-order-for-casino-entity',
  UPDATE_CASINO_GAME_THUMB: "/admin-panel-casino/v1/games/{game_id}/thumbnail", // 'update-casino-game-thumb',
  UPDATE_CASINO_ENTITY_THUMB:
    "/admin-panel-casino/v1/entities/{entity_id}", // 'update-casino-entity-icon',
  GET_SPORTS_ORDERING: "/admin-panel/feature-management/v1/sports-ordering",
  GET_CASINO_PROVIDERS: "/admin-panel-casino/v1/providers",
  GET_ALL_SPORTS_ENTITIES_BY_TYPE: "/admin-panel/feature-management/v1/entities/by-type", // 'get-entities-by-type'
  REORDER_ALL_SPORTS_ENTITIES: "/admin-panel/feature-management/v1/entities/reorder", // 'reorder-entities'
  REMOVE_CASINO_ENTITY: "/admin-panel-casino/v1/entities/{entity_id}", // 'remove-game-from-casino-entity',
  TOGGLE_GLOBAL_CASINO_GAME_STATUS: "/admin-panel-casino/v1/games/{game_id}/status", // Casino FM - Global Game Settings
  
  // Casino V2 - Global Game Settings
  GET_ALL_CASINO_GAMES_V2: "/admin-panel-casino/v2/casino-games", // Fetches ALL casino games, no pagination
  SYNC_CASINO_GAMES: "/admin-panel-casino/v1/sync", // Syncs all casino games with providers
  SEARCH_CASINO_GAMES_V2: "/admin-panel-casino/v2/casino-games/search", // Case insensitive search (name query param)
  TOGGLE_CASINO_GAME_V2: "/admin-panel-casino/v2/casino-games/toggle", // Sets is_active (body: game_id, provider, is_active)
  TOGGLE_CASINO_GAMES_BULK_V2: "/admin-panel-casino/v2/casino-games/toggle/bulk", // is_active + FM sync (one or many games)
  /** PATCH display name / optional clear thumbnail for a global casino game (Casino configuration). */
  PATCH_CASINO_CONFIGURATION_GAME_DETAILS:"/admin-panel-casino/v2/casino-games/details",
  CASINO_PRESIGNED_URL: "/admin-panel-casino/v2/presigned-url",
  ADMIN_UPLOADS_PRESIGNED: "/admin-panel-casino/v3/uploads/presigned",

  // Casino - Scheduled tasks (CASENG-1048)
  CASINO_SCHEDULED_TASKS: "/admin-panel-casino/v1/scheduled-tasks", // list runs (?purpose=&limit=)
  CASINO_SCHEDULED_TASKS_TRIGGER: "/admin-panel-casino/v1/scheduled-tasks/trigger",
  CASINO_SCHEDULED_TASK_RUN:
    "/admin-panel-casino/v1/scheduled-tasks/{correlation_id}",

  // Casino V3 - Providers (new configuration endpoints)
  GET_ADMIN_PROVIDERS: "/admin-panel-casino/v3/providers",
  DISCOVER_ADMIN_PROVIDERS: "/admin-panel-casino/v3/providers/discover",
  REGISTER_ADMIN_PROVIDER: "/admin-panel-casino/v3/providers",
  UPDATE_ADMIN_PROVIDER: "/admin-panel-casino/v3/providers/{identifier}",
  SET_PROVIDER_TAGS: "/admin-panel-casino/v3/providers/{provider_id}/tags",
  DELETE_PROVIDER_TAG: "/admin-panel-casino/v3/providers/{provider_id}/tags/{tag_id}",

  // Casino V3 - Collections
  GET_ADMIN_COLLECTIONS: "/admin-panel-casino/v3/collections",
  POST_ADMIN_COLLECTIONS: "/admin-panel-casino/v3/collections",
  GET_ADMIN_COLLECTION: "/admin-panel-casino/v3/collections/{code}",
  PATCH_ADMIN_COLLECTION: "/admin-panel-casino/v3/collections/{code}",
  DELETE_ADMIN_COLLECTION: "/admin-panel-casino/v3/collections/{code}",
  GET_COLLECTION_GAMES: "/admin-panel-casino/v3/collections/{code}/games",
  GET_COLLECTION_GAME_GROUPS: "/admin-panel-casino/v3/collections/{code}/games/groups/provider",
  GET_COLLECTION_PROVIDER_GAMES: "/admin-panel-casino/v3/collections/{code}/games/groups/provider/{provider}/games",
  POST_COLLECTION_GAMES: "/admin-panel-casino/v3/collections/{code}/games",
  DELETE_COLLECTION_GAME: "/admin-panel-casino/v3/collections/{code}/games/{provider}/{game_id}",
  GET_COLLECTION_CONFIG: "/admin-panel-casino/v3/config",
  MOVE_COLLECTION_GAME: "/admin-panel-casino/v3/collections/{code}/games/move",
  MOVE_COLLECTION_GAME_PROVIDER: "/admin-panel-casino/v3/collections/{code}/games/groups/provider/{provider}/move",
  MOVE_COLLECTION_PROVIDER_GROUP: "/admin-panel-casino/v3/collections/{code}/games/groups/provider/move",
  PIN_COLLECTION_GAME: "/admin-panel-casino/v3/collections/{code}/games/popular",
  COLLECTION_GAME_POPULAR: "/admin-panel-casino/v3/collections/{code}/games/{provider}/{game_id}/popular",

  // Casino V3 - Storefront pages (e.g. Social Casino, Live casino)
  GET_ADMIN_PAGES: "/admin-panel-casino/v3/pages",
  CREATE_ADMIN_PAGE: "/admin-panel-casino/v3/pages",
  UPDATE_ADMIN_PAGE: "/admin-panel-casino/v3/pages/{code}",
  DELETE_ADMIN_PAGE: "/admin-panel-casino/v3/pages/{code}",

  // Casino V3 - Views (storefront views: carousels, shortcuts, ...)
  GET_ADMIN_VIEWS: "/admin-panel-casino/v3/views",
  GET_ADMIN_VIEW_PLACEMENTS:
    "/admin-panel-casino/v3/views/{view}/placements",
  ADD_ADMIN_VIEW_PLACEMENTS:
    "/admin-panel-casino/v3/views/{view}/placements",
  MOVE_ADMIN_VIEW_PLACEMENT:
    "/admin-panel-casino/v3/views/{view}/placements/move",
  // NB: PATCH_ and DELETE_ deliberately share the same URL template; the
  // distinction is the HTTP verb. Keep both constants so callers don't have
  // to know that two operations target the same resource.
  PATCH_ADMIN_VIEW_PLACEMENT:
    "/admin-panel-casino/v3/views/{view}/placements/{code}",
  DELETE_ADMIN_VIEW_PLACEMENT:
    "/admin-panel-casino/v3/views/{view}/placements/{code}",

  // Casino V3 - Collection Providers (for kind: "providers")
  GET_COLLECTION_PROVIDERS: "/admin-panel-casino/v3/collections/{code}/providers",
  DELETE_COLLECTION_PROVIDER: "/admin-panel-casino/v3/collections/{code}/providers/{identifier}",
  MOVE_COLLECTION_PROVIDER: "/admin-panel-casino/v3/collections/{code}/providers/move",
  GET_COLLECTION_PROVIDER_ITEMS: "/admin-panel-casino/v3/collections/{code}/providers/{provider_id}/items",
  MOVE_COLLECTION_PROVIDER_ITEM: "/admin-panel-casino/v3/collections/{code}/providers/{provider_id}/items/move",

  TOGGLE_CASINO_ENTITY_CATEGORY:
    "/admin-panel-casino/v1/entities/{entity_id}/category",
  TOGGLE_CASINO_ENTITY_COLLECTION:
    "/admin-panel-casino/v1/entities/{entity_id}/collection",


  // Casino V3 - Games (new configuration endpoints)
  GET_ADMIN_GAMES_TREE: "/admin-panel-casino/v3/games/tree",
  GET_ADMIN_GAMES: "/admin-panel-casino/v3/games",
  BULK_ACTIVE_GAMES: "/admin-panel-casino/v3/games/bulk-active",
  BULK_ACTIVE_GAMES_BY_IDS: "/admin-panel-casino/v3/games/bulk-active-by-ids",
  GET_ADMIN_TAGS: "/admin-panel-casino/v3/tags",
  POST_ADMIN_TAG: "/admin-panel-casino/v3/tags",
  // NB: PATCH and DELETE share the same URL template as GET-by-id; the verb
  // is what distinguishes the operation. The current Tags admin page only
  // needs PATCH (edit name/color); tag_id itself is the URL key and immutable.
  PATCH_ADMIN_TAG: "/admin-panel-casino/v3/tags/{tag_id}",
  SET_GAME_TAGS: "/admin-panel-casino/v3/games/{provider}/{game_id}/tags",
  DELETE_GAME_TAG: "/admin-panel-casino/v3/games/{provider}/{game_id}/tags/{tag_id}",

  // Casino V3 - Big Winners (casino-home showcase config). Served by the
  // casino config service under the `/admin-panel-casino/v3` gateway, following
  // the same pattern as the other v3 casino config routes (e.g. `v3/games/tree`,
  // `v3/tags`).
  GET_BIG_WINNERS_CONFIG: "/admin-panel-casino/v3/big-winners",
  PUT_BIG_WINNERS_CONFIG: "/admin-panel-casino/v3/big-winners",
  POST_BIG_WINNERS_REFRESH: "/admin-panel-casino/v3/big-winners/refresh",

  // Casino V3 - Jackpot (CASENG-926). Enable flag + per-game rail via
  // reserved collection special_jackpot. Paths mirror the public API contract
  // under the admin-panel-casino gateway.
  GET_JACKPOT_CONFIG: "/admin-panel-casino/v3/jackpot",
  PUT_JACKPOT_CONFIG: "/admin-panel-casino/v3/jackpot",
  POST_JACKPOT_GAME: "/admin-panel-casino/v3/jackpot/games",
  PATCH_JACKPOT_GAME:
    "/admin-panel-casino/v3/jackpot/games/{provider}/{game_id}",
  DELETE_JACKPOT_GAME:
    "/admin-panel-casino/v3/jackpot/games/{provider}/{game_id}",

  // Casino FM
  CREATE_CASINO_GROUP: "/admin-panel-casino/v2/groups",
  GET_CASINO_GROUPS: "/admin-panel-casino/v2/groups",
  DELETE_CASINO_GROUP: "/admin-panel-casino/v2/groups/{group_id}",
  UPDATE_CASINO_GROUP: "/admin-panel-casino/v2/groups/{entity_id}",
  CREATE_CASINO_SUBCATEGORY: "/admin-panel-casino/v2/subcategories",
  GET_LIVE_CASINO_SUBCATEGORIES: "/admin-panel-casino/v2/subcategories",
  UPDATE_LIVE_CASINO_SUBCATEGORY:
    "/admin-panel-casino/v2/subcategories/{subcategory_id}",
  DELETE_CASINO_SUBCATEGORY: "/admin-panel-casino/v2/subcategories/{subcategory_id}",
  GET_CASINO_SUBCATEGORY_GAMES:
    "/admin-panel-casino/v2/subcategories/{subcategory_id}/games?subcategory_id={subcategory_id}",
  CREATE_CASINO_SUBCATEGORY_GAME:
    "/admin-panel-casino/v2/subcategories/{subcategory_id}/games",
  UPDATE_CASINO_SUBCATEGORY_GAME:
    "/admin-panel-casino/v2/subcategories/{subcategory_id}/games/{provider_id}/{game_id}",
  PIN_CASINO_SUBCATEGORY_GAME:
    "/admin-panel-casino/v2/subcategories/{subcategory_id}/games/{provider_id}/{game_id}",
  DELETE_CASINO_SUBCATEGORY_GAME:
    "/admin-panel-casino/v2/subcategories/{subcategory_id}/games/{provider_id}/{game_id}",
  GET_CASINO_GAMES_V2: "/admin-panel-casino/v2/casino-games",
  // Casino FM - Popular games
  GET_POPULAR_GAMES: "/admin-panel-casino/v2/games/popular",
  UPDATE_POPULAR_GAMES_BY_ENTITY:
    "/admin-panel-casino/v2/games/popular/{entity_id}",
  REORDER_POPULAR_GAMES: "/admin-panel-casino/v2/games/popular/reorder",

  // Casino FM - Providers
  GET_CASINO_PROVIDERS_V2: "/admin-panel-casino/v2/providers",
  GET_CASINO_PROVIDERS_GLOBAL: "/admin-panel-casino/v2/providers/global",
  GET_CASINO_PROVIDER_GLOBAL:
    "/admin-panel-casino/v2/providers/global/{provider_id}",
  CREATE_CASINO_PROVIDER_GLOBAL: "/admin-panel-casino/v2/providers/global",
  DELETE_CASINO_PROVIDER_GLOBAL:
    "/admin-panel-casino/v2/providers/global/{group_id}",
  CREATE_PROVIDER_GAME: "/admin-panel-casino/v2/games/provider",
  UPDATE_CASINO_PROVIDER: "/admin-panel-casino/v2/providers/{provider_id}",
  UPDATE_GLOBAL_CASINO_PROVIDER:
    "/admin-panel-casino/v2/providers/global/{provider_id}",
  GET_PROVIDER_GAMES: "/admin-panel-casino/v2/games/provider",
  UPDATE_PROVIDER_GAME: "/admin-panel-casino/v2/games/provider/{entity_id}",
  DELETE_PROVIDER_GAME: "/admin-panel-casino/v2/games/provider/{entity_id}",
  INVOKE_SCHEDULED_TASK: "/admin-panel-casino/v2/entities/create-defaults",

  // Feature Management - Shortcuts
  GET_SHORTCUTS_ORDERING: "/admin-panel/feature-management/v1/shortcuts", // 'get-shortcuts-ordering'
  ADD_SHORTCUT: "/admin-panel/feature-management/v1/shortcuts", // 'get-shortcuts-ordering'
  UPDATE_SHORTCUTS_ORDERING: "/admin-panel/feature-management/v1/shortcuts/reorder", // 'reorder-shortcuts'
  PIN_SHORTCUT: "/admin-panel/feature-management/v1/shortcuts/pin", // 'pin-shortcut'
  UNPIN_SHORTCUT: "/admin-panel/feature-management/v1/shortcuts/unpin", // 'unpin-shortcut'
  UPDATE_SHORTCUT_STATUS: "/admin-panel/feature-management/v1/shortcuts/status", // 'set-shortcut-activity-status'
  UPDATE_SHORTCUT_NAME: "/admin-panel/feature-management/v1/shortcuts/rename", // 'rename-shortcut'
  DELETE_SHORTCUT: "/admin-panel/feature-management/v1/shortcuts/delete", // 'delete-shortcut'
  GET_POTENTIAL_SHORTCUTS_AUTOCOMPLETE: "/admin-panel/feature-management/v1/shortcuts/autocomplete", // 'get-potential-shortcuts-autocomplete'
  
  // Feature Management - ShortcutsV2
  GET_SHORTCUTS_ORDERING_V2: "/admin-panel/feature-management/v2/shortcuts", // 'get-shortcuts-ordering'
  ADD_SHORTCUT_V2: "/admin-panel/feature-management/v2/shortcuts", // 'get-shortcuts-ordering'
  UPDATE_SHORTCUTS_ORDERING_V2: "/admin-panel/feature-management/v2/shortcuts/order", // 'reorder-shortcuts'
  UPDATE_SHORTCUT_STATUS_V2: "/admin-panel/feature-management/v2/shortcuts/set-active", // 'set-shortcut-activity-status'
  UPDATE_SHORTCUT_NAME_V2: "/admin-panel/feature-management/v2/shortcuts/rename", // 'rename-shortcut'
  DELETE_SHORTCUT_V2: "/admin-panel/feature-management/v2/shortcuts", // 'delete-shortcut'
  GET_POTENTIAL_SHORTCUTS_AUTOCOMPLETE_V2: "/admin-panel/feature-management/v2/shortcuts/autocomplete", // 'get-potential-shortcuts-autocomplete'
  UPDATE_SHORTCUT_LOGO_V2: "/admin-panel/feature-management/v2/shortcuts/logo",
  RESET_SHORTCUT_LOGO_V2: "/admin-panel/feature-management/v2/shortcuts/logo/reset",

  // Feature Management - Live Sports
  GET_LIVE_SPORTS_ORDERING: "/admin-panel/feature-management/v1/sports-ordering", // 'get-sports-ordering'
  GET_ENTITIES_BY_TYPE: "/admin-panel/feature-management/v1/get-entities-by-type", // 'get-entities-by-type'
  GET_LIVE_SPORTS_GAMES: "/admin-panel/feature-management/v1/live-games", // 'get-live-sports-games'
  GET_LIVE_EVENTS_BY_SPORT_ID: "/admin-panel/feature-management/v1/live-events", // 'get-live-events-by-sport-id'
  SET_ENTITY_ACTIVE_STATUS: "/admin-panel/feature-management/v1/entities/status", // 'set-entity-active-status'
  PIN_ENTITY: "/admin-panel/feature-management/v1/pin-entity", // 'pin-entity'
  UNPIN_ENTITY: "/admin-panel/feature-management/v1/unpin-entity", // 'unpin-entity'
  REORDER_ENTITIES: "/admin-panel/feature-management/v1/live-entities/reorder", // 'reorder-entities'
  UPDATE_ALL_SPORTS_S3: "/admin-panel/feature-management/v1/all-sports/refresh-cache", // 'update-all-sports-s3'

  // Feature Management - Event Markets
  GET_EVENT_MARKETS_SPORTS: "/admin-panel/feature-management/v1/markets/sports",
  GET_MARKET_ENTITIES_BY_TYPE: "/admin-panel/feature-management/v1/markets/entities",
  REORDER_MARKET_ENTITIES: "/admin-panel/feature-management/v1/markets/reorder",
  CREATE_NEW_MARKET_TAB: "/admin-panel/feature-management/v1/markets/tab",
  UPDATE_MARKET_TAB: "/admin-panel/feature-management/v1/markets/tab",
  CREATE_NEW_MARKET_CARD: "/admin-panel/feature-management/v1/markets/card",
  RENAME_MARKET: "/admin-panel/feature-management/v1/markets/rename",
  DELETE_MARKET_CARD: "/admin-panel/feature-management/v1/markets/card",
  DELETE_MARKET_TAB: "/admin-panel/feature-management/v1/markets/tab",
  GET_SPORT_MARKETS_AUTOCOMPLETE: "/admin-panel/feature-management/v1/markets/autocomplete",

  // Customer Support Controls
  GET_GLOBAL_VARIABLE: "/admin-panel/settings/v1/variables/{name}", // 'get-global-variable',
  TOGGLE_CASINO_NAVIGATION_TAB: "/admin-panel-casino/v2/navigation-tab",

  // Manual Entries
  GET_MANAGERS: "/get-managers",
  GET_MANUAL_ENTRIES_ANALYTICS: "/get-manual-entries-analytics",
  GET_MANUAL_ENTRIES_PAGINATED: "/get-manual-entries-paginated",
  GET_SUPPORT_AGENTS: "/get-support-agents",

  // Transactions - Wallet
  GET_WALLET_TRANSACTIONS: "/admin-panel-transactions/v1/get-wallets",
  GET_WALLET_TRANSACTIONS_TABLE: "/admin-panel-transactions/v1/reports",
  GET_DEPOSITS_BY_PLATFORM: "/admin-panel-transactions/v1/deposits-by-platform",
  GET_TRANSACTION_VOLUME: "/admin-panel-transactions/v1/transaction-volume",
  GET_REDEEMABLE_CASH: "/admin-panel-transactions/v1/redeemable-cash",
  GET_SUBREGION_DATA: "/admin-panel-transactions/v1/subregion-overview",
  GET_KPI_OVERVIEW: "/admin-panel-transactions/v1/kpi-overview",
  
    // Transactions - Withdrawal Review
  GET_PENDING_TRANSACTIONS:
    "/admin-panel-payments/v1/withdrawals/pending-transactions",
  GET_PROCESSED_TRANSACTIONS:
    "/admin-panel-payments/v1/withdrawals/processed-transactions",
  GET_IN_PROGRESS_TRANSACTIONS:
    "/admin-panel-payments/v1/withdrawals/in-progress-transactions",
  GET_PENDING_TRANSACTIONS_DOWNLOAD:
    "/admin-panel-payments/v1/withdrawals/pending-transactions/download",
  GET_IN_PROGRESS_TRANSACTIONS_DOWNLOAD:
    "/admin-panel-payments/v1/withdrawals/in-progress-transactions/download",
  GET_PROCESSED_TRANSACTIONS_DOWNLOAD:
    "/admin-panel-payments/v1/withdrawals/processed-transactions/download",
  GET_TRANSACTION_DETAILS:
    "/admin-panel-payments/v1/withdrawals/get-transaction-details",
  APPROVE_PENDING_TRANSACTION:
    "/admin-panel-payments/v1/withdrawals/approve-transaction",
  DECLINE_PENDING_TRANSACTION:
    "/admin-panel-payments/v1/withdrawals/decline-transaction",
  REFUND_PENDING_TRANSACTION:
    "/admin-panel-payments/v1/withdrawals/refund-transaction",

  GET_ACTIVE_WITHDRAWAL_RULES:
    "/admin-panel-v2/compliance/withdrawals/rules",
  PUBLISH_WITHDRAWAL_RULES: "/admin-panel-v2/compliance/withdrawals/rules",
  LIST_WITHDRAWAL_RULE_VERSIONS:
    "/admin-panel-v2/compliance/withdrawals/rules/versions",

  // Fraud / GLI rule (singleton — GET and PATCH same resource)
  FRAUD_RULE: "/admin-panel-transactions/v1/fraud/rule",
  POST_FRAUD_RULE_SET_ACTIVE: "/admin-panel-transactions/v1/fraud/rule/set-active",
  POST_FRAUD_FLAGGED_USERS_LIST: "/admin-panel-transactions/v1/fraud/flagged-users/list",
  POST_FRAUD_FLAGGED_USERS_DOWNLOAD:
    "/admin-panel-transactions/v1/fraud/flagged-users/download",

  // Duplicate identity review (VER-444) — lives on admin_panel_v2's
  // contexts/compliance/duplicate_identity slice.
  GET_DUPLICATE_IDENTITY_GROUPS:
    "/admin-panel-v2/compliance/duplicate-identity/groups",
  GET_DUPLICATE_IDENTITY_GROUP_DETAIL:
    "/admin-panel-v2/compliance/duplicate-identity/groups/{group_id}",
  PATCH_DUPLICATE_IDENTITY_GROUP:
    "/admin-panel-v2/compliance/duplicate-identity/groups/{group_id}",
  POST_DUPLICATE_IDENTITY_MERGE_DRY_RUN:
    "/admin-panel-v2/compliance/duplicate-identity/groups/{group_id}/merge-dry-run",

  // User analytics (KPIs tab v2 acquisition section)
  /** Aggregate user-acquisition KPIs (new users, FTD count/amount, total users, ...) */
  GET_USER_ANALYTICS_KPIS: "/admin-panel-v2/users/analytics/kpis",
  /** Per-day signups / FTDs / FTD amount, used by the Users daily-breakdown chart. */
  GET_USER_ANALYTICS_DAILY: "/admin-panel-v2/users/analytics/kpis/daily",
  /** Per-month signups / FTDs, used by the rolling 12-month Users chart. */
  GET_USER_ANALYTICS_MONTHLY: "/admin-panel-v2/users/analytics/kpis/monthly",
  /** Per-state aggregates, used by the Acquisition geographic-insights map. */
  GET_USER_ANALYTICS_BY_STATE: "/admin-panel-v2/users/analytics/kpis/by-state",

  // Sportsbook
  /** Daily analytics summary on admin-panel-v2; requires sportsbook.analytics.table */
  GET_SPORTSBOOK_ANALYTICS_SUMMARY:
    "/admin-panel-v2/sportsbook/analytics/summary",
  /** Aggregate KPIs (turnover/pnl/margin) on admin-panel-v2; requires sportsbook.analytics. */
  GET_SPORTSBOOK_ANALYTICS_KPIS:
    "/admin-panel-v2/sportsbook/analytics/summary/kpis",
  GET_SPORTSBOOK_PROFITABILITY_TOP_SPORTS:
    "/admin-panel-v2/sportsbook/analytics/summary/top-sports",
  GET_SPORTSBOOK_PROFITABILITY_TOP_SPORTS_EXPORT:
    "/admin-panel-v2/sportsbook/analytics/summary/top-sports/export",
  GET_SPORTSBOOK_PROFITABILITY_TOP_EVENTS:
    "/admin-panel-v2/sportsbook/analytics/summary/top-events",
  GET_SPORTSBOOK_PROFITABILITY_TOP_EVENTS_EXPORT:
    "/admin-panel-v2/sportsbook/analytics/summary/top-events/export",
  GET_EARLY_PAYOUT_RULES: "/admin-panel-sportsbook/v1/early-payout/rules",
  GET_EARLY_PAYOUT_SELECTORS: "/admin-panel-sportsbook/v1/early-payout/selectors",
  CREATE_EARLY_PAYOUT_SELECTOR: "/admin-panel-sportsbook/v1/early-payout/selectors",
  UPDATE_EARLY_PAYOUT_SELECTOR:
    "/admin-panel-sportsbook/v1/early-payout/selectors/{selector_id}",
  DELETE_EARLY_PAYOUT_SELECTOR:
    "/admin-panel-sportsbook/v1/early-payout/selectors/{selector_id}",
  CREATE_EARLY_PAYOUT_RULE: "/admin-panel-sportsbook/v1/early-payout/rules",
  GET_EARLY_PAYOUT_SPORTS_DROPDOWN:
    "/admin-panel-sportsbook/v1/early-payout/dropdowns/sports",
  GET_EARLY_PAYOUT_MARKETS_DROPDOWN:
    "/admin-panel-sportsbook/v1/early-payout/dropdowns/markets",
  GET_EARLY_PAYOUT_LEAGUES_DROPDOWN:
    "/admin-panel-sportsbook/v1/early-payout/dropdowns/leagues",
  GET_EARLY_PAYOUT_EVENTS_DROPDOWN:
    "/admin-panel-sportsbook/v1/early-payout/dropdowns/events",
  UPDATE_EARLY_PAYOUT_RULE:
    "/admin-panel-sportsbook/v1/early-payout/rules/{rule_id}",
  DELETE_EARLY_PAYOUT_RULE:
    "/admin-panel-sportsbook/v1/early-payout/rules/{rule_id}",
  GET_SGP_RISK_LIST: "/admin-panel-sportsbook/v1/sgp-risk/list",
  GET_SGP_RISK_SPORTS_DROPDOWN:
    "/admin-panel-sportsbook/v1/sgp-risk/dropdowns/sports",
  UPDATE_SGP_RISK_EXPOSURE_CONTROLS:
    "/admin-panel-sportsbook/v1/sgp-risk/exposure-controls",
  GET_SGP_RISK_BETS_LIST: "/admin-panel-sportsbook/v1/sgp-risk/bets-list",
  GET_SGP_SPORT_LIMITS: "/admin-panel-sportsbook/v1/sgp-risk/sport-limits",
  UPDATE_SGP_SPORT_LIMITS: "/admin-panel-sportsbook/v1/sgp-risk/sport-limits",
  GET_SGP_SPORTS_COUNTRIES_TREE:
    "/admin-panel-sportsbook/v1/sgp-risk/dropdowns/sports-countries-tree",
  GET_SGP_LEAGUE_LIMITS: "/admin-panel-sportsbook/v1/sgp-risk/league-limits",
  UPDATE_SGP_LEAGUE_LIMITS: "/admin-panel-sportsbook/v1/sgp-risk/league-limits",
  GET_SPORTSBOOK_OVERVIEW: "/admin-panel-sportsbook/v1/sportsbook-overview",
  GET_TOTAL_EVENTS_DATA: "/admin-panel-sportsbook/v1/events-status-counts",
  GET_BET_TIMING_ANALYSIS: "/admin-panel-sportsbook/v1/bet-timing-analysis",
  GET_SPORTSBOOK_BETS_REPORT: "/get-sportsbook-table",
  GET_SPORTSBOOK_EVENTS_LIST: "/admin-panel-sportsbook/v1/events-list/list",
  GET_SPORTSBOOK_EVENTS_LIST_PROVIDERS_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/providers-dropdown",
  GET_SPORTSBOOK_EVENTS_LIST_EVENT_TYPE_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/event-type-dropdown",
  GET_SPORTSBOOK_EVENTS_LIST_STATUS_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/status-dropdown",
  GET_SPORTSBOOK_EVENTS_LIST_SPORTS_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/sports-dropdown",
  GET_SPORTSBOOK_EVENTS_LIST_LEAGUES_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/leagues-dropdown",
  GET_SPORTSBOOK_EVENTS_LIST_EVENTS_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/events-dropdown",

  // Sportsbook promo restriction dropdowns (BONENG-980)
  GET_SPORTSBOOK_PROMO_TOURNAMENTS_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/leagues-dropdown",
  GET_SPORTSBOOK_PROMO_MATCHES_DROPDOWN: "/admin-panel-sportsbook/v1/events-list/events-dropdown",
  GET_SPORTSBOOK_PROMO_MARKETS_DROPDOWN: "/admin-panel-sportsbook/v1/early-payout/dropdowns/markets",

  GET_MARGIN_BY_BET_TYPE: "/admin-panel-sportsbook/v1/bet-type-margin-data",
  GET_LEAGUE_DISTRIBUTION_DATA:
    "/admin-panel-sportsbook/v1/league-distribution-data",
  GET_TICKET_LENGTH_BREAKDOWN:
    "/admin-panel-sportsbook/v1/ticket-length-pie-data",
  GET_SPORT_SELECTION_DISTRIBUTION:
    "/admin-panel-sportsbook/v1/sports-pie-data",
  GET_TICKET_LENGTH_DISTRIBUTION:
    "/admin-panel-sportsbook/v1/ticket-length-ggr-turnover-data",
  GET_USER_LIFECYCLE_TIME_SERIES: "/admin-panel-sportsbook/v1/user-lifecycle-data",
  GET_SPORT_PERFORMANCE_DATA: "/admin-panel-sportsbook/v1/sportsbook-performance-data",
  GET_MARGIN_DATA: "/admin-panel-sportsbook/v1/margin-data",
  GET_USERS_BY_STATE: "/admin-panel-sportsbook/v1/users-by-state-data",
  GET_USER_METADATA: "/user_metadata",
  GET_POPULAR_MARKETS: "/admin-panel-sportsbook/v1/popular-markets",
  GET_LIVE_EVENT_ENTITIES: "/admin-panel/feature-management/v1/live-events",
  UPDATE_SPORTSBOOK_SPORT_NAME: "/admin-panel/feature-management/v1/entities/rename-sport",
  // Sportsbook FM translations (SPENG-2723 / proposed SPENG-2747 contract).
  GET_SPORTSBOOK_FM_TRANSLATION:
    "/admin-panel/feature-management/v1/translations/{entity_key}",
  UPDATE_SPORTSBOOK_FM_TRANSLATION:
    "/admin-panel/feature-management/v1/translations/{entity_key}/{locale}",
  DELETE_SPORTSBOOK_FM_TRANSLATION:
    "/admin-panel/feature-management/v1/translations/{entity_key}/{locale}",

  // Poker
  // POKENG-141/142/191: cash-game config, keyed by ?currency=&visibility=.
  // Path anticipates the published v2 contract (POKENG-142 comment thread,
  // Jul 21) — adjust here if the final route differs.
  POKER_CASH_GAME_CONFIG: "/admin-panel/poker/v2/config",
  GET_USER_POKER_STATS: "/admin-panel-users/v1/{user_id}/poker/stats",
  GET_USER_POKER_GAMES: "/admin-panel-users/v1/{user_id}/poker/games",
  GET_USER_POKER_HANDS: "/admin-panel-users/v1/{user_id}/poker/games/{game_id}/hands",
  GET_USER_POKER_HAND_DETAILS:
    "/admin-panel-users/v1/{user_id}/poker/games/{game_id}/hands/{hand_number}",

  // Event Details
  GET_EVENT_MARKETS: "/admin-panel-sportsbook/v1/get-event-details-markets-data",
  GET_EVENT_DETAILS_KPI_BET_TYPES: "/admin-panel-sportsbook/v1/event-kpi/bet-types",
  GET_EVENT_DETAILS_KPI_BET_ACTIVITY: "/admin-panel-sportsbook/v1/event-kpi/bet-activity",
  GET_EVENT_DETAILS_KPI_BET_STATUS: "/admin-panel-sportsbook/v1/event-kpi/bet-statuses",
  GET_EVENT_DETAILS_KPI_MARKET_TYPES: "/admin-panel-sportsbook/v1/event-kpi/market-types",
  GET_EVENT_DETAILS_KPI_TABLE: "/admin-panel-sportsbook/v1/event-kpi/table",
  GET_EVENT_DETAILS_KPI_DAILY_HISTOGRAM: "/admin-panel-sportsbook/v1/event-kpi/daily-histogram",
  GET_EVENT_DETAILS_KPI_OVERVIEW: "/admin-panel-sportsbook/v1/event-kpi/overview",
  GET_EVENT_DETAILS_KPI_USER_STATE_MAP: "/admin-panel-sportsbook/v1/event-kpi/user-state-map",
  GET_EVENT_DETAILS_HEADER: "/admin-panel-sportsbook/v1/event-kpi/header",
  GET_MARKETS_FILTERS: "/admin-panel-payments/v1/get-event-details-markets-data",
  GET_EVENT_DETAILS_DATA: "/admin-panel-sportsbook/v1/get-event-details-markets-data",
  GET_EVENT_DETAILS_TABLE: "/admin-panel-sportsbook/v1/event-kpi/bets-table",

  // Mobile Build Downloads
  GET_MOBILE_BUILDS: "/mobile-builds/v1/list",
  DOWNLOAD_MOBILE_BUILD: "/mobile-builds/v1/download",

  // Feature Flags
  GET_FEATURE_FLAG: "/settings/v1/feature-flags",
  UPDATE_FEATURE_FLAG: "/settings/v1/feature-flags",

  // Feature Management - Top Leagues
  GET_TOP_LEAGUES_ORDERING: '/admin-panel/feature-management/v1/top-leagues/list',
  REORDER_TOP_LEAGUE_ENTITIES: '/admin-panel/feature-management/v1/top-leagues/reorder',
  DELETE_TOP_LEAGUE: '/admin-panel/feature-management/v1/top-leagues/delete',
  CREATE_NEW_TOP_LEAGUE: '/admin-panel/feature-management/v1/top-leagues/create',
  GET_POTENTIAL_TOP_LEAGUES_AUTOCOMPLETE:'/admin-panel/feature-management/v1/top-leagues/autocomplete',
  SET_TOP_LEAGUE_ENTITY_ACTIVITY_STATUS:'/admin-panel/feature-management/v1/top-leagues/set-active',
  GET_EVENTS_BY_TOP_LEAGUE: '/admin-panel/feature-management/v1/top-leagues/events',
  PIN_FEATURED_EVENT: '/admin-panel/feature-management/v1/top-leagues/pin-event',
  UNPIN_FEATURED_EVENT: '/admin-panel/feature-management/v1/top-leagues/unpin-event',


  // Feature Management - Popular Tabs
  GET_POPULAR_TABS: '/admin-panel/feature-management/v2/popular',
  SET_POPULAR_TAB_STATUS: '/admin-panel/feature-management/v2/popular/set-active',
  ORDER_POPULAR_TABS: '/admin-panel/feature-management/v2/popular/order',
  AUTOCOMPLETE_POPULAR_TABS: '/admin-panel/feature-management/v2/popular/autocomplete',
  CREATE_NEW_POPULAR_TAB: '/admin-panel/feature-management/v2/popular',
  DELETE_POPULAR_TAB: '/admin-panel/feature-management/v2/popular',
  RENAME_POPULAR_TAB: '/admin-panel/feature-management/v2/popular/rename',

  // Feature Management - Upcoming Tabs
  GET_UPCOMING_TABS: '/admin-panel/feature-management/v2/upcoming',
  SET_UPCOMING_TAB_STATUS: '/admin-panel/feature-management/v2/upcoming/set-active',
  ORDER_UPCOMING_TABS: '/admin-panel/feature-management/v2/upcoming/order',
  AUTOCOMPLETE_UPCOMING_TABS: '/admin-panel/feature-management/v2/upcoming/autocomplete',
  CREATE_NEW_UPCOMING_TAB: '/admin-panel/feature-management/v2/upcoming',
  DELETE_UPCOMING_TAB: '/admin-panel/feature-management/v2/upcoming',
  RENAME_UPCOMING_TAB: '/admin-panel/feature-management/v2/upcoming/rename',
  

  // Feature Management - Top Markets
  GET_TOP_MARKETS: '/admin-panel/feature-management/v2/top-markets?sport_id={sport_id}&event_type={event_type}&include_deleted=false&include_inactive=true',
  AUTOCOMPLETE_TOP_MARKETS: '/admin-panel/feature-management/v2/top-markets/autocomplete?sport_id={sport_id}&event_type={event_type}&search_term={search_term}&limit=30',
  CREATE_NEW_TOP_MARKET: '/admin-panel/feature-management/v2/top-markets',
  DELETE_TOP_MARKET: '/admin-panel/feature-management/v2/top-markets',
  ORDER_TOP_MARKETS: '/admin-panel/feature-management/v2/top-markets/order',
  RENAME_TOP_MARKET: '/admin-panel/feature-management/v2/top-markets/rename',

  // Feature Management - Futures
  // season_id is appended by the caller only when a season is available.
  GET_FUTURES_ENTITIES: '/admin-panel/feature-management/v2/futures?sport_id={sport_id}&league_id={league_id}',
  GET_FUTURES_LEAGUES: '/admin-panel/feature-management/v2/futures/leagues?sport_id={sport_id}',
  GET_FUTURES_TRAITS: '/admin-panel/feature-management/v2/futures/traits?sport_id={sport_id}&league_id={league_id}',
  CREATE_FUTURES_ENTITY: '/admin-panel/feature-management/v2/futures',
  UPDATE_FUTURES_ENTITY: '/admin-panel/feature-management/v2/futures',
  DELETE_FUTURES_ENTITY: '/admin-panel/feature-management/v2/futures',
  ORDER_FUTURES_ENTITIES: '/admin-panel/feature-management/v2/futures/order',
  GET_FUTURES_MARKETS_AUTOCOMPLETE: '/admin-panel/feature-management/v2/futures/autocomplete?sport_id={sport_id}&league_id={league_id}',

  // Feature Management - Top Leagues Per Sport
  GET_TOP_LEAGUES_PER_SPORT: '/admin-panel/feature-management/v2/sport-leagues?sport_id={sport_id}&event_type={event_type}&include_deleted=false&include_inactive=true',
  AUTOCOMPLETE_TOP_LEAGUES_PER_SPORT: '/admin-panel/feature-management/v2/sport-leagues/autocomplete?sport_id={sport_id}&event_type={event_type}&search_term={search_term}&limit=30',
  CREATE_NEW_TOP_LEAGUES_PER_SPORT: '/admin-panel/feature-management/v2/sport-leagues',
  RENAME_TOP_LEAGUES_PER_SPORT: '/admin-panel/feature-management/v2/sport-leagues/rename',
  DELETE_TOP_LEAGUES_PER_SPORT: '/admin-panel/feature-management/v2/sport-leagues',
  ORDER_TOP_LEAGUES_PER_SPORT: '/admin-panel/feature-management/v2/sport-leagues/order',

  // Live Sports V2
  GET_LIVE_SPORTS_V2: '/admin-panel/feature-management/v2/live?include_inactive=true',
  SET_LIVE_SPORTS_V2_ACTIVE: '/admin-panel/feature-management/v2/live/set-active',
  REORDER_LIVE_SPORTS_V2: '/admin-panel/feature-management/v2/live/order',
  RENAME_LIVE_SPORTS_V2: '/admin-panel/feature-management/v2/live/rename',

  // GAME DETAILS - 
  GET_GAME_TOP_WINNERS: '/admin-panel-casino/v1/top-players/winners',
  GET_GAME_TOP_LOSERS: '/admin-panel-casino/v1/top-players/losers',
  GET_GAME_TOP_TURNOVER: '/admin-panel-casino/v1/top-players/turnover',
  GET_GAME_DETAILS_CONFIGURATION:
    '/admin-panel-casino/v1/game-details/configuration',
  UPDATE_GAME_DETAILS_DESCRIPTION:
    '/admin-panel-casino/v1/game-details/configuration/description',

  // CASINO KPI
  GET_CASINO_KPI_AVAILABLE_FILTERS: '/admin-panel-casino/v1/kpi/available-filters',
  GET_CASINO_KPI_GAMES_STATS: '/admin-panel-casino/v1/kpi/games/stats',
  GET_CASINO_KPI_BETS_BY_STATE: '/admin-panel-casino/v1/kpi/bets/by-state',
  GET_CASINO_KPI_GAMES_RANK: '/admin-panel-casino/v1/kpi/games/rank',
  GET_CASINO_KPI_CATEGORIES_RANK: '/admin-panel-casino/v1/kpi/categories/rank',
  GET_CASINO_KPI_BETS_BY_PROVIDER: '/admin-panel-casino/v1/kpi/bets/by-provider',
  GET_CASINO_KPI_OVERVIEW: '/admin-panel-casino/v1/kpi/overview',
  GET_CASINO_KPI_OVERVIEW_BREAKDOWN: '/admin-panel-casino/v1/kpi/overview/breakdown',

  /** Casino Analytics daily summary (PAMENG-1720) — GET with start_date, end_date, limit, cursor. */
  GET_CASINO_ANALYTICS_SUMMARY: "/admin-panel-v2/casino/analytics/summary",
  /** Casino Analytics KPI totals (same date window as summary table). */
  GET_CASINO_ANALYTICS_KPIS: "/admin-panel-v2/casino/analytics/summary/kpis",
  /**
   * Casino Analytics — per-provider table (PAMENG-1725 / PAMENG-1812).
   * Query: page, size, start_date, end_date, search, sort
   */
  GET_CASINO_ANALYTICS_PROVIDERS: "/admin-panel-v2/casino/analytics/providers",
  /**
   * Casino Analytics — per-game table.
   * Query: start_date, end_date, page, size, search, sort, provider, category
   */
  GET_CASINO_ANALYTICS_GAMES: "/admin-panel-v2/casino/analytics/games",

  // USER MANAGER - GAME PASS (admin-panel backend)
  GET_MONTHLY_CHALLENGE_INFO: '/admin-panel/game-pass/v1/get-monthly-challenge-info',
  GET_WEEKLY_CHALLENGE_INFO: '/admin-panel/game-pass/v1/get-weekly-challenge-info',
  EDIT_TASK: '/admin-panel/game-pass/v1/edit-task',

  // GAME PASS - Seasons (Configuration listing)
  // Query: status (optional) — draft | scheduled | locked | active | grace | completed | cancelled
  GET_GAME_PASS_CONFIG: "/gamepass/v2/admin/config",
  // Catalogue powering the Create Task / Create Challenge dropdowns:
  // sports, leagues, BE enums, rule metadata, social event types, casino
  // providers. Response: { success, data: { ... } }.
  GET_GAME_PASS_TASK_OPTIONS: "/gamepass/v2/admin/task-options",
  // Casino games catalogue powering the Create Task casino provider/game
  // picker. PROVIDERS returns { providers: [{ name, total, active }],
  // total_games }. GAMES returns { games: [{ game_id, name, provider,
  // category, is_active }], filtered_total, unfiltered_total, limit, offset }
  // and is filtered with `provider` (list a provider's games) or `search`
  // (case-insensitive name search across providers), paginated via
  // `limit` / `offset`.
  GET_GAME_PASS_CASINO_PROVIDERS:
    "/gamepass/v2/admin/casino-games/providers",
  GET_GAME_PASS_CASINO_GAMES: "/gamepass/v2/admin/casino-games",
  // GAME PASS - User Manager (dashboard/game-pass-admin backend)
  GET_GAME_PASS_USER_PROGRESS: "/gamepass/v2/admin/users/{user_id}/progress",
  GET_GAME_PASS_USER_STATS: "/gamepass/v2/admin/users/{user_id}/stats",
  // Lists every season the user has enrolled in (title, status, dates, path).
  // Fetch per-season progress separately via GET_GAME_PASS_USER_PROGRESS.
  GET_GAME_PASS_USER_ENROLLMENTS:
    "/gamepass/v2/admin/users/{user_id}/enrollments",
  GET_GAME_PASS_USER_ELIGIBLE_BETS:
    "/gamepass/v2/admin/users/{user_id}/eligible-bets",
  // Sportsbook / casino bet history and social-event history for the User
  // Manager Game Pass support surface (container-agnostic — season or campaign).
  GET_GAME_PASS_USER_BETS: "/gamepass/v2/admin/users/{user_id}/bets",
  GET_GAME_PASS_USER_CASINO_BETS:
    "/gamepass/v2/admin/users/{user_id}/casino-bets",
  GET_GAME_PASS_USER_SOCIAL_EVENTS:
    "/gamepass/v2/admin/users/{user_id}/social-events",
  // PAM forensic login-streak table (FE-2664). Additive `days: []` on the
  // StreakHistoryResponse — one row per challenge day, oldest-first.
  GET_GAME_PASS_USER_STREAK_HISTORY:
    "/gamepass/v2/admin/users/{user_id}/tasks/{task_id}/streak-history",
  PASS_GAME_PASS_USER_TASK:
    "/gamepass/v2/admin/users/{user_id}/tasks/{task_id}/pass",
  // Bump a task's count/streak without force-completing. Auto-completes when
  // the bump crosses target_value. Same path works for season and campaign tasks.
  INCREMENT_GAME_PASS_USER_TASK:
    "/gamepass/v2/admin/users/{user_id}/tasks/{task_id}/increment",
  GET_GAME_PASS_ADMIN_SEASONS: "/gamepass/v2/admin/seasons",
  GET_GAME_PASS_ADMIN_CHALLENGES: "/gamepass/v2/admin/challenges",
  // Game Pass player-facing theme (admin surface). GET returns the current
  // theme in a `{ success, data: { colors, assets, updated_at, published } }`
  // envelope. Keys inside colors / assets are FE-owned free-form strings —
  // adding a new slot never needs a backend deploy.
  GET_GAME_PASS_THEME: "/gamepass/v2/admin/theme",
  // Merge-patch the theme (same path, same envelope). Send only the dirty
  // keys: a string sets/overwrites that key, `null` removes it (reset to
  // default), an absent key is left untouched. The response body is the merged
  // result; `data.published` reports whether the CDN copy was refreshed.
  PATCH_GAME_PASS_THEME: "/gamepass/v2/admin/theme",
  // Pre-signed S3 upload for Game Pass images (challenge icons / task images).
  // POST body: { key, content_type }. Response: { upload_url, public_url }.
  // PUT the file to `upload_url`, then persist `key` as `img_key` on the
  // challenge / task create or update payload.
  GAME_PASS_PRESIGN: "/gamepass/v2/admin/s3/presign",
  CREATE_SEASON: "/gamepass/v2/admin/seasons",
  GET_SEASONS_LIST: "/gamepass/v2/admin/seasons",
  UPDATE_SEASON: "/gamepass/v2/admin/seasons/{season_id}",
  DELETE_SEASON: "/gamepass/v2/admin/seasons/{season_id}",
  SCHEDULE_SEASON: "/gamepass/v2/admin/seasons/{season_id}/schedule",
  UNSCHEDULE_SEASON: "/gamepass/v2/admin/seasons/{season_id}/unschedule",
  ACTIVATE_SEASON: "/gamepass/v2/admin/seasons/{season_id}/activate",
  // Unlock a `locked` ("Up Next") season so it returns to `scheduled` and
  // becomes editable again. Response carries the updated season record.
  UNLOCK_SEASON: "/gamepass/v2/admin/seasons/{season_id}/unlock",
  CANCEL_SEASON: "/gamepass/v2/admin/seasons/{season_id}/cancel",
  END_SEASON: "/gamepass/v2/admin/seasons/{season_id}/complete",
  // Clone an existing season into a brand-new draft (challenges + tasks
  // copied). Response carries the newly created season record.
  CLONE_SEASON: "/gamepass/v2/admin/seasons/{season_id}/clone",
  // GAME PASS - Challenges
  // `sort_order` is zero-based within the season.
  CREATE_CHALLENGE: "/gamepass/v2/admin/challenges",
  GET_CHALLENGES_LIST: "/gamepass/v2/admin/challenges",
  // PUT body is partial; send only editable challenge metadata (name,
  // description, sort_order, img_key). Rewards are persisted separately via
  // UPDATE_CHALLENGE_REWARD.
  // `{challenge_id}` is the server-assigned id returned by CREATE_CHALLENGE.
  UPDATE_CHALLENGE: "/gamepass/v2/admin/challenges/{challenge_id}",
  // Authoritative replacement for a challenge's reward set. PUT body:
  // `{ rewards: [{ amount, currency, tier }, ...] }`. Send `[]` to clear all.
  UPDATE_CHALLENGE_REWARD: "/gamepass/v2/admin/challenges/{challenge_id}/reward",
  // DELETE a single challenge. `{challenge_id}` is the server-assigned id.
  DELETE_CHALLENGE: "/gamepass/v2/admin/challenges/{challenge_id}",

  // GAME PASS - Tasks
  // POST body carries `season_id` + `challenge_id` (+ challenge metadata).
  // Season must be in `draft` or `scheduled` status for create/update to succeed.
  CREATE_TASK: "/gamepass/v2/admin/tasks",
  // GET listing of every task on a season. Query: season_id (required).
  // Tasks carry their parent `challenge_id` / `challenge` so the Season
  // Details editor can group them under the matching challenge card.
  GET_TASKS_LIST: "/gamepass/v2/admin/tasks",
  // PUT body sends only the fields you want to change. Optional fields
  // (`bet_type`, `min_odds_american`, `min_leg_count`, `outcome_required`,
  // `sports`, `rules`) can be cleared by sending `null` explicitly.
  // `{task_id}` is the server-assigned id returned by CREATE_TASK.
  UPDATE_TASK: "/gamepass/v2/admin/tasks/{task_id}",
  // DELETE a single task. `{task_id}` is the server-assigned id returned by
  // CREATE_TASK. Season must be in `draft` or `scheduled` status (BE-gated).
  DELETE_TASK: "/gamepass/v2/admin/tasks/{task_id}",

  // GAME PASS - Monthly Challenges (Campaigns)
  // A Monthly Challenge is a campaign container that holds challenge groups +
  // tiered tasks (reusing the CREATE_CHALLENGE / CREATE_TASK contract above,
  // with `campaign_id` in place of `season_id`). Campaigns are editable only
  // while `draft` / `scheduled`; the config freezes on activation.
  // PROVISIONAL (FE-2319): paths follow the backend Monthly Challenges wiring
  // guide — confirm against the admin OpenAPI before GA.
  CREATE_CAMPAIGN: "/gamepass/v2/admin/campaigns",
  // GET listing. Query: status (optional) — draft | scheduled | active |
  // completed | cancelled.
  GET_CAMPAIGNS_LIST: "/gamepass/v2/admin/campaigns",
  // GET a single campaign by its server-assigned id (Monthly Details page).
  GET_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}",
  // PUT partial update — send only changed campaign metadata. Campaign must be
  // in `draft` / `scheduled` status.
  UPDATE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}",
  DELETE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}",
  // Lifecycle transitions — each echoes the updated campaign record.
  SCHEDULE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}/schedule",
  UNSCHEDULE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}/unschedule",
  ACTIVATE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}/activate",
  COMPLETE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}/complete",
  CANCEL_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}/cancel",
  // Clone an existing campaign into a brand-new draft (challenges + tasks
  // copied). Response carries the newly created campaign record — mirrors
  // CLONE_SEASON.
  CLONE_CAMPAIGN: "/gamepass/v2/admin/campaigns/{campaign_id}/clone",

  // Staff Management
  // Self-scoped staff preferences. PATCH body: { language?, timezone? } (at
  // least one field). A 404 means the endpoint isn't deployed yet — callers
  // feature-detect and fall back to localStorage-only persistence.
  PATCH_STAFF_ME_PREFERENCES: "/admin-panel-staff/v2/staff/me/preferences",
  CREATE_STAFF: "/admin-panel-staff/v2/staff",
  UPDATE_STAFF: "/admin-panel-staff/v2/staff/{admin_id}",
  GET_STAFF_DETAILS: "/admin-panel-staff/v2/staff/{admin_id}",
  STAFF_RESET_PASSWORD: "/admin-panel-staff/v2/staff/{admin_id}/reset-password",
  STAFF_RESET_MFA: "/admin-panel-staff/v2/staff/{admin_id}/reset-mfa",
  STAFF_CHANGE_EMAIL: "/admin-panel-staff/v2/staff/{admin_id}/email",
  DISABLE_STAFF: "/admin-panel-staff/v2/staff/{admin_id}/disable",
  GET_STAFF: "/admin-panel-staff/v2/staff",
  STAFF_ROLES_DROPDOWN: "/admin-panel-staff/v2/staff/roles-dropdown",
  STAFF_STATUS_DROPDOWN: "/admin-panel-staff/v2/staff/status-dropdown",
  STAFF_RAINBOW: "/admin-panel-staff/v2/staff/rainbow",


  // Staff Roles (RBAC)
  ROLES_PERMISSIONS_SCHEMA: "/admin-panel-staff/v2/roles/permissions-schema",
  ROLES_LIST: "/admin-panel-staff/v2/roles",
  ROLE_GET: "/admin-panel-staff/v2/roles/{role_id}",
  ROLE_CREATE: "/admin-panel-staff/v2/roles",
  ROLE_UPDATE: "/admin-panel-staff/v2/roles/{role_id}",
  ROLE_DELETE: "/admin-panel-staff/v2/roles/{role_id}",
  ROLE_COPY: "/admin-panel-staff/v2/roles/{role_id}/copy",

  // Staff Activity Log
  GET_STAFF_ACTIVITY_LOG: "/admin-panel-staff/v2/staff/{admin_id}/activity",

  // Agent Audit Log (PAM v2). Paths are also built by
  // queries/agent-audit-log/aalV2.ts from AGENT_AUDIT_LOG_BASE.
  AGENT_AUDIT_LOG_BASE: "/admin-panel-v2/support/staff/agent-audit-log",

  // Financials KPIs
  FINANCIALS_KPI_CARDS: "/admin-panel-v2/financials/analytics/kpis",
  FINANCIALS_DAILY_PERFORMANCE: "/admin-panel-v2/financials/analytics/kpis/daily",
  FINANCIALS_MONTHLY: "/admin-panel-v2/financials/analytics/kpis/monthly",
  FINANCIALS_REDEEMABLE_DAILY:
    "/admin-panel-v2/financials/analytics/transactions/redeemable/daily",
  FINANCIALS_DEPOSITS_BY_PLATFORM:
    "/admin-panel-v2/financials/analytics/transactions/deposits/by-platform",
  FINANCIALS_BY_STATE:
    "/admin-panel-v2/financials/analytics/kpis/by-state",

  // Acquisition / Users KPIs
  ACQUISITION_KPI_CARDS: "/admin-panel-v2/users/analytics/kpis",

  // Casino KPIs
  CASINO_KPI_CARDS: "/admin-panel-v2/casino/analytics/kpis",
  CASINO_DAILY_PERFORMANCE: "/admin-panel-v2/casino/analytics/kpis/daily",
  CASINO_TOP_PROVIDERS: "/admin-panel-v2/casino/analytics/kpis/top-providers",
  CASINO_TOP_GAMES: "/admin-panel-v2/casino/analytics/kpis/top-games",
  CASINO_BY_STATE_V2: "/admin-panel-v2/casino/analytics/kpis/by-state",
  CASINO_TOP_USERS: "/admin-panel-v2/casino/analytics/top-users",
  CASINO_TOP_USERS_KPIS:
    "/admin-panel-v2/casino/analytics/top-users/kpis",

  // sportsbook KPIs v2
  SPORTSBOOK_KPI_CARDS: "/admin-panel-v2/sportsbook/analytics/kpis",
  SPORTSBOOK_DAILY_PERFORMANCE:
    "/admin-panel-v2/sportsbook/analytics/kpis/daily",
  SPORTSBOOK_TOP_SPORTS: "/admin-panel-v2/sportsbook/analytics/kpis/top-sports",
  SPORTSBOOK_TOP_LEAGUES: "/admin-panel-v2/sportsbook/analytics/kpis/top-leagues",
  SPORTSBOOK_BY_STATE: "/admin-panel-v2/sportsbook/analytics/kpis/by-state",
  // Sportsbook → Reporting → Top Users (auth: sportsbook.reporting.top_users)
  SPORTSBOOK_TOP_USERS: "/admin-panel-v2/sportsbook/analytics/top-users",
  SPORTSBOOK_TOP_USERS_KPIS:
    "/admin-panel-v2/sportsbook/analytics/top-users/kpis",

  PROMOTIONS_ACQUISITION_KPIS: "/admin-panel-v2/promotions/acquisition/kpis",
  PROMOTIONS_ACQUISITION_SOURCES: "/admin-panel-v2/promotions/acquisition/sources",

  // Banner creative presign (BONENG-522): S3 upload URL for PNG banner images,
  // used by the campaign banner editor's Upload Image button.
  CAROUSEL_BANNER_PRESIGN: "/admin-panel-v2/promotions/carousel-banners/presigned-url",

  // Feature Quick Access / Profile Shortcuts (Configurations → Profile).
  // GET returns the full list; PUT replaces the full list; POST /icon
  // accepts JSON { shortcut_id, image: data-URL } (JPEG/JPG/PNG/SVG, 512 KB).
  GET_PROFILE_SHORTCUTS: "/admin-panel-v2/configurations/profile-shortcuts",
  PUT_PROFILE_SHORTCUTS: "/admin-panel-v2/configurations/profile-shortcuts",
  PROFILE_SHORTCUT_ICON_UPLOAD:
    "/admin-panel-v2/configurations/profile-shortcuts/icon",

  // Casino KPIs v2 (full Casino KPI page)
  CASINO_ANALYTICS_KPI_CARDS: "/admin-panel-casino/v1/analytics/kpis/cards",
  CASINO_TRANSACTIONS: "/admin-panel-casino/v1/analytics/transactions",
  CASINO_PROVIDERS_GAMES: "/admin-panel-casino/v1/analytics/providers-games",
  CASINO_TOP_FIVE: "/admin-panel-casino/v1/analytics/top-five",
  CASINO_PROVIDER_DISTRIBUTION:
    "/admin-panel-casino/v1/analytics/provider-distribution",
  CASINO_BY_STATE: "/admin-panel-casino/v1/analytics/by-state",

  // Dynamic Bonuses (admin-panel-v2 proxy → bonus-service-v2)
  CREATE_DYNAMIC_BONUS_TEMPLATE: "/admin-panel-v2/bonus/dynamic-bonuses/templates",
  LIST_DYNAMIC_BONUS_TEMPLATES:  "/admin-panel-v2/bonus/dynamic-bonuses/templates",
  GET_DYNAMIC_BONUS_TEMPLATE:      "/admin-panel-v2/bonus/dynamic-bonuses/templates/{template_id}",
  CLONE_DYNAMIC_BONUS_TEMPLATE:    "/admin-panel-v2/bonus/dynamic-bonuses/templates/{template_id}/clone",
  UPDATE_DYNAMIC_BONUS_TEMPLATE:   "/admin-panel-v2/bonus/dynamic-bonuses/templates/{template_id}",
  DELETE_DYNAMIC_BONUS_TEMPLATE:   "/admin-panel-v2/bonus/dynamic-bonuses/templates/{template_id}",
  CREATE_DYNAMIC_BONUS_CAMPAIGN: "/admin-panel-v2/bonus/dynamic-bonuses/campaigns",
  LIST_DYNAMIC_BONUS_CAMPAIGNS:  "/admin-panel-v2/bonus/dynamic-bonuses/campaigns",
  GET_DYNAMIC_BONUS_CAMPAIGN:      "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}",
  CLONE_DYNAMIC_BONUS_CAMPAIGN:    "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}/clone",
  UPDATE_DYNAMIC_BONUS_CAMPAIGN:   "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}",
  DELETE_DYNAMIC_BONUS_CAMPAIGN:   "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}",
  ACTIVATE_DYNAMIC_BONUS_CAMPAIGN: "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}/activate",
  PAUSE_DYNAMIC_BONUS_CAMPAIGN:    "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}/pause",
  EXPIRE_DYNAMIC_BONUS_CAMPAIGN:   "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}/expire",
  TEST_SEND_DYNAMIC_BONUS_CAMPAIGN: "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/{campaign_id}/test-send",
  TEST_SEND_DRAFT_DYNAMIC_BONUS_CAMPAIGN: "/admin-panel-v2/bonus/dynamic-bonuses/campaigns/test-send",
  LIST_ADMIN_PANEL_USERS: "/admin-panel-v2/users",
  DYNAMIC_BONUS_CATALOG:           "/admin-panel-v2/bonus/dynamic-bonuses/catalog",
  DYNAMIC_BONUS_EVENTS:            "/admin-panel-v2/bonus/dynamic-bonuses/events",
  // Segments proxy route (matches the parallel admin-services segments router)
  CREATE_DYNAMIC_BONUS_SEGMENT:    "/admin-panel-v2/bonus/segments",
  LIST_DYNAMIC_BONUS_SEGMENTS:     "/admin-panel-v2/bonus/segments",
  GET_DYNAMIC_BONUS_SEGMENT:       "/admin-panel-v2/bonus/segments/{segment_id}",
  UPDATE_DYNAMIC_BONUS_SEGMENT:    "/admin-panel-v2/bonus/segments/{segment_id}",
  ACTIVATE_DYNAMIC_BONUS_SEGMENT:  "/admin-panel-v2/bonus/segments/{segment_id}/activate",
  PAUSE_DYNAMIC_BONUS_SEGMENT:     "/admin-panel-v2/bonus/segments/{segment_id}/pause",
  LIST_SEGMENT_MEMBERS:            "/admin-panel-v2/bonus/segments/{segment_id}/members",
  // Series proxy routes (BONENG-842, matches the admin-services series router)
  CREATE_DYNAMIC_BONUS_SERIES:     "/admin-panel-v2/bonus/dynamic-bonuses/series",
  LIST_DYNAMIC_BONUS_SERIES:       "/admin-panel-v2/bonus/dynamic-bonuses/series",
  GET_DYNAMIC_BONUS_SERIES:        "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}",
  UPDATE_DYNAMIC_BONUS_SERIES:     "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}",
  DELETE_DYNAMIC_BONUS_SERIES:     "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}",
  ACTIVATE_DYNAMIC_BONUS_SERIES:   "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}/activate",
  PAUSE_DYNAMIC_BONUS_SERIES:      "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}/pause",
  LIST_DYNAMIC_BONUS_SERIES_RUNS:  "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}/runs",
  GET_DYNAMIC_BONUS_SERIES_BRAZE_PAYLOAD:
    "/admin-panel-v2/bonus/dynamic-bonuses/series/{series_id}/braze-payload",
};


//
// export const SLASHLESS_API_ROUTES = {
//
//     // public routes
//     LOG_IN: 'onboarding/sign-in',
//     GET_PERMISSIONS: 'get-admin-permission',
//
//     // user routes
//     GET_USERS: 'all-users',
//     SEARCH_USER: 'search-user',
//     GET_USER_BETS: 'get-user-bets',
//     GET_BET_BY_ID: 'retrieve-bet-details',
//     EDIT_USER_PROFILE: 'edit-user-profile',
//     EDIT_USER_WALLET: 'update-user-wallet',
//     DELETE_USER: 'delete-user',
//     CHANGE_USER_ACH: 'update-user-ach-status',
//     SUSPEND_UNSUSPEND_USER: 'suspend-unsuspend-user',
//     GET_TRANSACTION_HISTORY: 'get-user-transaction-history',
//     GET_PAYMENT_INSTRUMENTS: 'fetch-user-bank-accounts',
//     DELETE_ALL_PAYMENT_INSTRUMENTS: 'delete-user-bank-accounts',
//     DELETE_SPECIFIC_PAYMENT_INSTRUMENT: 'delete-bank-from-bank-list',
//     SEND_EMAIL_VERIFICATION: 'send-verification-code-to-email',
//     EDIT_SINGLE_BET: 'settle-sportbook-bet',
//     EDIT_PARLAY_BET: 'settle-parlay-bet',
//
//     // kpi routes
//     GET_SPORTRADAR_BET_METRICS: 'get-betting-metrics',
//     REFRESH_SPORTRADAR_BET_METRICS: 'refresh-betting-metrics',
//     GET_TOTAL_NUM_USERS: 'get-total-users',
//     GET_TOTAL_EMAIL_VERIFIED: 'get-email-status',
//     GET_TOTAL_PLAID_VERIFIED: 'get-plaid-status',
//
//     // admin routes
//     CREATE_ADMIN: 'create-admin-user',
//     EDIT_ADMIN: 'update-admin-permission',
//     GET_ADMINS: 'get-admins',
// }
